module.exports = __webpack_public_path__ + "static/media/ard_mobile.87231411.png";